import { ResultType } from "../hooks/useFetchWithMsal";

export function getReportURL(execute: Function, endpoint: string, reportURLFunction: Function, blobIsEmptyOrUndefined: Function) {
    execute('GET', endpoint, undefined, 'application/json', ResultType.Blob)
        .then(
            ((blob: Blob) => {
                if (blob) {
                    var reportPdf = blob.slice(0, blob.size, 'application/pdf');
                    reportURLFunction(URL.createObjectURL(reportPdf));
                } else {
                    blobIsEmptyOrUndefined();
                }
            })
        );
}